import { ActionStateModel, SetActiveAll, SetActiveById, SetDisableAll, SetDisableById } from "../../../Models/StateModel/ActionStateModel";
import { RootAction } from "../../Actions/RootAction";

const initialState = {
    actionState: new ActionStateModel()
}

const actionState = (state = initialState, action) => {
    switch (action.type) {
        case RootAction.ActionState.SetActiveAll:
            let activeState = SetActiveAll(state.actionState);
            return {
                ...state,
                actionState: activeState
            };

        case RootAction.ActionState.SetDisableAll:
            let disableState = SetDisableAll(state.actionState);
            return {
                ...state,
                actionState: disableState
            };

        case RootAction.ActionState.SetActiveById:
            let activeStateById = SetActiveById(state.actionState, action.data.Ids);
            return {
                ...state,
                actionState: activeStateById
            };

        case RootAction.ActionState.SetDisableById:
            let disableStateById = SetDisableById(state.actionState, action.data.Ids);
            return {
                ...state,
                actionState: disableStateById
            };

        default:
            break;
    }

    return state;
}

export default actionState;